import {Component, OnInit, ViewChild} from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';
import { ImportContainer } from "../../../Model/dataProcess/importContainer";
import { ExportContainer } from "../../../Model/dataProcess/exportContainer";
import { ProductDataSource } from "../../../Model/dataProcess/productDataSource";
import { DataSourcesService } from "../../../Services/DataProcess/datasources.service";
import { LoginService } from "../../../Services/login.service";
import { DxFileUploaderTypes } from 'devextreme-angular/ui/file-uploader';
import { ImportContainerService } from "../../../Services/DataProcess/import-container.service";
import { BeforeSendEvent } from "devextreme/ui/file_uploader";
import { OAuthService } from "angular-oauth2-oidc";
import { SystemService } from "../../../Services/system.service";
import { confirm } from 'devextreme/ui/dialog';
import {DxContextMenuComponent} from "devextreme-angular";
import DevExpress from "devextreme";
import ContextMenuItem = DevExpress.ui.dxFileManager.ContextMenuItem;

const TAG_COLORS = ['#1f6fd1', '#7b3fbf', '#2e8b57', '#e07b14', '#c2185b', '#00838f'];
const CHANGE_TAG_COLOR = '#e07b14';

@Component({
    selector: "np-import-page",
    templateUrl: "./importPage.component.html",
    styleUrls: ["./importPage.component.css"],
    standalone: false
})

export class ImportPageComponent implements OnInit {
    containers: ImportContainer[];
    filteredContainers: ImportContainer[] = [];
    tagOptions: string[] = [];
    selectedTags: string[] = [];
    editedContainer: ImportContainer;
    containerSearchText: string;
    containerEditVisible = false;
    dataSources: ProductDataSource[];
    selectedContainer: ImportContainer = null;
    changeTag: string;
   @ViewChild('catalogContextMenu', {static: false}) catalogContextMenu: DxContextMenuComponent;
    constructor(
        public translate: TranslateService,
        private router: Router,
        private dataSourceService: DataSourcesService,
        private loginService: LoginService,
        private importContainerService: ImportContainerService,
        private oAuthService: OAuthService,
        private systemService: SystemService
    ) {
        this.systemService.currentNavigationTitle = this.translate.instant('Importe');
        this.changeTag = this.translate.instant('Änderung');
        this.altExpr = this.altExpr.bind(this);
        this.calculateDataSourceTags = this.calculateDataSourceTags.bind(this);
    }

  containerEditMode: boolean = false;
  contextMenuItems: ContextMenuItem[];
    
  async ngOnInit() {

    this.contextMenuItems = [
      {
        id: 0,
        text: this.translate.instant("Editieren..."),
        icon: 'glyphicon glyphicon-eye-open',
        beginGroup: true
      },
      {
        id: 1,
        text: this.translate.instant("Duplizieren..."),
        icon: 'glyphicon glyphicon-copy',
        beginGroup: true
      },
      {
        id: 2,
        text: this.translate.instant("Löschen..."),
        icon: 'glyphicon glyphicon-trash',
        beginGroup: true
      },
    ];
  await this.reloadLookups();
        await this.reloadContainers();
    }

    
  onCatalogOverflowClicked(container: ImportContainer, event: any): void {
    if ( container == null) {
      return;
    }
    this.catalogContextMenu.instance.option('target', event.event.currentTarget);
    this.catalogContextMenu.instance.option('position', {
      my: 'left top',
      at: 'left bottom',
      offset: '0 5'
    });
    this.catalogContextMenu.instance.show();
  }

  async itemClick(e: any): Promise<void> {
    var container = this.selectedContainer;
    switch (e.itemIndex) {
      case 0:
        this.openContainerEditPopupWithContainer(container);
        break;
      case 1:
        await this.duplicateContainer(container);
        await  this.reloadContainers();
        break;
      case 2:
        await this.deleteContainer(container);
        await  this.reloadContainers();
        break;
    }
  }
  
  async reloadContainers() {
        this.containers = await this.importContainerService.getAll(this.loginService.currentCustomer.id) ?? [];
        this.tagOptions = [...new Set(this.containers.flatMap(c => this.containerTags(c)))].sort((a, b) => a.localeCompare(b));
        this.selectedTags = this.selectedTags.filter(tag => this.tagOptions.includes(tag));
        this.applyTagFilter();
        if (!this.selectedContainer && this.containers.length > 0) {
            // Delay selection by one tick so the card-view renders its data
            // and instantiates the Angular footer templates before selectedCardKeys is applied.
            setTimeout(() => {
                if (!this.selectedContainer && this.containers.length > 0) {
                    this.selectedContainer = this.containers[0];
                }
            });
        }
    }

  async duplicateContainer(container: ImportContainer) {
    var duplicateContainer = structuredClone(container);
    duplicateContainer.id = null;
    duplicateContainer.createdByUserId = this.loginService.currentUser.id;
    duplicateContainer.name += "_COPY"
    await this.importContainerService.create(duplicateContainer, this.loginService.currentCustomer.id);
  }

  async deleteContainer(container: ImportContainer) {
    const confirmed = await confirm(
      this.translate.instant('Soll der Container wirlich gelöscht werden? -') + ' <b>' + container.name + '</b> ',
      this.translate.instant('Container löschen')
    );
    if (!confirmed) {
      return;
    }
    await this.importContainerService.deleteByContainerId(container.id, container.createdByUserId, this.loginService.currentCustomer.id);
    await this.reloadContainers();
  }
    calculateCatalogCount(container: ImportContainer) {
        return container.catalogIds?.length ?? 0;
    }

    calculateDataSourceTags(container: ImportContainer) {
        return this.containerTags(container).join(', ');
    }

    containerTags(container: ImportContainer): string[] {
        const tags = container?.dataSourceTags ?? [];
        return container?.lastCatalogImport && !tags.includes(this.changeTag) ? [...tags, this.changeTag] : tags;
    }

    onTagFilterChanged(tags: string[]): void {
        this.selectedTags = tags ?? [];
        this.applyTagFilter();
    }

    applyTagFilter(): void {
        this.filteredContainers = this.selectedTags.length === 0
            ? this.containers
            : this.containers.filter(c => this.containerTags(c).some(tag => this.selectedTags.includes(tag)));
    }

    tagColor(tag: string): string {
        if (tag === this.changeTag) {
            return CHANGE_TAG_COLOR;
        }
        const hash = [...tag].reduce((sum, char) => (sum * 31 + char.charCodeAt(0)) >>> 0, 0);
        return TAG_COLORS[hash % TAG_COLORS.length];
    }

    imageExpr(container: ImportContainer): string {
        return container?.logoLink;
    }

    altExpr(): string {
        return this.translate.instant("Fehler beim Laden des Logos");
    }

    onContainerClicked(event: any) {
        const data: ImportContainer = event?.card?.data ?? event?.data ?? null;
        if (data) {
            this.selectedContainer = data;
        }
    }

    goToDetails(container: ImportContainer) {
        const id = container?.id;
        if (id) {
            this.router.navigate(['/dataprocess/imports/container-details', id]);
        }
    }

    openContainerEditPopup() {
        this.containerEditVisible = true;
        this.containerEditMode = false;
        this.editedContainer = new ImportContainer();
    }

  openContainerEditPopupWithContainer(container:ImportContainer) {
    this.containerEditMode = true;
    this.containerEditVisible = true;
    this.editedContainer = container;
  }
    onBeforeSendUpload(event: BeforeSendEvent) {
        event.request.withCredentials = true;
        event.request.setRequestHeader('Authorization', 'Bearer ' + this.oAuthService.getAccessToken());
    }

    async onUploaded(e: DxFileUploaderTypes.UploadedEvent) {
        this.editedContainer.logoLink = e.request.responseText as string;
    }

    async onContainerSaved(container: ImportContainer | ExportContainer) {
        let containerId = container.id;
        await this.reloadContainers();
        this.selectedContainer = this.containers.find(c => c.id === containerId) ?? null;
    }

    async onContainerDeleted() {
        this.selectedContainer = null;
        await this.reloadContainers();
    }

    async onContainerDuplicated(container: ImportContainer | ExportContainer) {
        await this.reloadContainers();
        this.selectedContainer = this.containers.find(c => c.id === container?.id) ?? null;
    }

    private async reloadLookups() {
        this.dataSources = await this.dataSourceService.getAll(this.loginService.currentCustomer.id) ?? [];
    }
}
